const links = [
  { name: '.COM', link: '/dot/com' },
  { name: '.ANY', link: '/dot/any' },
  { name: '.CANNABIS', link: '/dot/cannabis' },
  { name: '.TAILORED', link: '/dot/tailored' },
];

export default links;